export const ESTIMATE_UNITS = ["hours", "days", "weeks", "months"] as const;

export type EstimateUnit = (typeof ESTIMATE_UNITS)[number];

/** A day is 24 hours, a week is 7 days, and a month is 30 days — the same clock the cycle already uses. */
export const ESTIMATE_UNIT_HOURS: Record<EstimateUnit, number> = {
  hours: 1,
  days: 24,
  weeks: 168,
  months: 720,
};

const SINGULAR: Record<EstimateUnit, string> = {
  hours: "hour",
  days: "day",
  weeks: "week",
  months: "month",
};

export function isEstimateUnit(value: string): value is EstimateUnit {
  return (ESTIMATE_UNITS as readonly string[]).includes(value);
}

export function estimateLabel(amount: number, unit: EstimateUnit): string {
  const count = Math.max(1, Math.round(amount));
  return `${count} ${count === 1 ? SINGULAR[unit] : unit}`;
}

/** Break a span of hours into months, weeks, days, and hours. */
export function formatHourSpan(totalHours: number): string {
  let left = Math.max(0, Math.round(totalHours));
  const parts: string[] = [];
  for (const unit of ["months", "weeks", "days", "hours"] as const) {
    const size = ESTIMATE_UNIT_HOURS[unit];
    const count = Math.floor(left / size);
    if (count <= 0) continue;
    parts.push(estimateLabel(count, unit));
    left -= count * size;
  }
  return parts.join(" ") || "0 hours";
}
